module.exports = __webpack_public_path__ + "img/class-of-2026-super-g.976fc193.jpg";